import Meta from '../components/Meta';
import {
  SaleTableBuyNowFilterConfigs,
  SaleTableColumnSets,
} from '../components/SaleTable.columns';
import SaleTablePage from '../components/SaleTablePage';
import queryDefs from '../lib/queryDefs';

const csvDownloadUrl = `https://d3ry1h4w5036x1.cloudfront.net/reports/Namecheap_Market_Sales_Buy_Now.csv`;

export default function BuyNow() {
  return (
    <>
      <Meta
        canonical="https://www.namecheap.com/market/"
        description="Find domain names for sale and purchase them right away in our Buy Now section. It’s your chance to get a great deal today."
        robots="all"
        title="Buy premium domains - Namecheap"
      />
      <SaleTablePage
        csvDownloadUrl={csvDownloadUrl}
        filterConfigs={SaleTableBuyNowFilterConfigs}
        query={queryDefs.buyNowTable}
        rowFilter={sale => {
          return !(
            ['fr', 'eu', 'best', 'ws'].includes(sale.product.tld) &&
            ['sedo', 'afternic'].includes(sale.inventory)
          );
        }}
        salesPath="binSales"
        showWatch={() => false}
        title="Buy Now"
        visibleColumns={() => SaleTableColumnSets.buynow}
      />
      <div className="tw-text-sm tw-text-center tw-mt-5 tw-pb-8 tw-px-2 tw-leading-tight">
        <a href={csvDownloadUrl}>Export all buy now domains to CSV</a>{' '}
        <small className="tw-text-xs tw-whitespace-nowrap">
          (Updates once per hour)
        </small>
      </div>
    </>
  );
}
